import React from 'react';
import styled from 'styled-components';
/**
 * * 상세보기 화면에서 쓰이는 헤더
 *  - 팩키지 페이지
 */

interface IProps {
  children: React.ReactElement;
  style?: React.CSSProperties;
}
const HeaderSection = ({ children, style }: IProps) => {
  return <Header style={style}>{children}</Header>;
};

export default HeaderSection;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 0.5rem;
  .title_box,
  .color_box {
    display: flex;
    align-items: center;
  }
  .color_box {
    margin-left: 1rem;
    > p {
      margin-left: 0.5rem;
    }
  }
`;
